import { useAuth } from "react-oidc-context";
import logo from './logo.svg';
import config from './config.js';
import './App.css';

function token2str(t) {
  if (t) {
    return JSON.stringify(JSON.parse(window.atob(t?.split(".")[1])), null, 2);
  }
}

function App() {
  const auth = useAuth();

  const signOutRedirect = () => {
    sessionStorage.clear();
    window.location.href = config.logoutURL;
  };

  if (auth.isLoading) {
    return <div className="App-body">>Loading...</div>;
  }

  if (window.location.search) {
    window.location.search = "";
  }

  if (auth.error) {
    return <div className="App-body">Encountering error... {auth.error.message}</div>;
  }

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
      </header>
      <div className="App-body">
        <div class="container-buttons">
          <button class="button button-1" onClick={() => auth.signinRedirect()}>Sign in</button>
          <button class="button button-1" onClick={() => signOutRedirect()}>Sign out</button>
        </div>
        <div>Authenticated: {auth.isAuthenticated ? "True" : "False"}</div>
        <div>User: {auth.user?.profile.email}</div>
        <div height="10vh">&nbsp;</div>
        <table>
          <thead>
            <td>ID Token</td>
            <td>Access Token</td>
          </thead>
          <tbody>
            <tr>
              <td style={{verticalAlign: 'top'}}><div class="scroll"><pre>{token2str(auth.user?.id_token)}</pre></div></td>
              <td style={{verticalAlign: 'top'}}><div class="scroll"><pre>{token2str(auth.user?.access_token)}</pre></div></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default App;
